module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/nav//mypet.png?v=5d5fa7f2";